import request from '@/utils/edu_request.js'

// 全部问答
export function QaAll(params) {
  return request({
    url: '/qa/index/all',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 我的提问
export function Qame(params) {
  return request({
    url: '/qa/index/question',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 我的回答
export function Qamyreply(params) {
  return request({
    url: '/qa/index/answer',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 提问
export function saveQa(params) {
  return request({
    url: '/qa/index/make',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 回复
export function reply(params) {
  return request({
    url: '/qa/index/reply',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// seeMore changeStatus
export function seeMore(params) {
  return request({
    url: '/qa/index/more',
    dataType: 'json',
    method: 'GET',
    params
  })
}
//  changeStatus
export function changeStatus(params) {
  return request({
    url: '/qa/index/read',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 已购列表seeMore
export function buylist(params) {
  return request({
    url: '/qa/index/have',
    dataType: 'json',
    method: 'GET',
    params
  })
}
// 是否购买zkb/index/isbuy?lesson_id=4448
export function isBuy(params) {
  return request({
    url: 'zkb/index/isbuy',
    method: 'GET',
    params
  })
}
// 删除问答|回复
export function delQa(params) {
  return request({
    url: 'qa/index/operate',
    method: 'get',
    params
  })
}
// 问答编辑
export function edlQa(params) {
  return request({
    url: 'qa/index/edit',
    method: 'post',
    data: params
  })
}
